import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { environment } from '../../../environments/environment';
import { ApiEnvironmentService } from '../services/api-environment.service';

/**
 * Reescreve o prefixo da URL (a base do build) pela base atualmente
 * selecionada no `ApiEnvironmentService`. Só faz efeito quando o build
 * é local — nos outros ambientes o service devolve sempre a mesma URL
 * que já está no environment, então esse interceptor vira no-op.
 */
export const apiEnvironmentInterceptor: HttpInterceptorFn = (req, next) => {
  const apiEnv = inject(ApiEnvironmentService);
  if (!apiEnv.canSwitch()) {
    return next(req);
  }

  const buildBase = environment.api.baseUrl;
  const runtimeBase = apiEnv.getCurrentBaseUrl();

  if (buildBase === runtimeBase || !req.url.startsWith(buildBase)) {
    return next(req);
  }

  const rewritten = req.clone({ url: runtimeBase + req.url.slice(buildBase.length) });
  return next(rewritten);
};
